/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { injectIntl, intlShape } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { Card } from 'lec-ui';

import messages from './panelMessages';

function DashboardCardsStudent(props) {
  const { cards, intl, myClass } = props;
  return (
    <div className="dashboard-card">
      <Row>
        <Col xs={6} md={6} lg={3} xl={3}>
          <Card className="card">
            <div className="number">{cards.availableClasses}</div>
            <div className="label-text">{intl.formatMessage(messages.availableClasses)}</div>
          </Card>
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <Card className="card">
            <div className="number">{cards.plannedClasses}</div>
            <div className="label-text">{intl.formatMessage(messages.plannedClasses)}</div>
          </Card>
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <Card className="card">
            <div className="number">{cards.overallProgress}%</div>
            <div className="label-text">{intl.formatMessage(messages.overallProgress)}</div>
          </Card>
        </Col>
        <Col xs={6} md={6} lg={3} xl={3}>
          <Card className="card" onClick={() => myClass()} style={{ cursor: 'pointer' }}>
            <div className="number">{cards.courses}</div>
            <div className="label-text">{intl.formatMessage(messages.courses)}</div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

DashboardCardsStudent.propTypes = {
  cards: PropTypes.objectOf(PropTypes.any),
  intl: intlShape,
  myClass: PropTypes.func.isRequired,
};

DashboardCardsStudent.defaultProps = {
  cards: {},
  intl: [],
};

export default compose(injectIntl)(DashboardCardsStudent);
